import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-booking-queue-management',
    templateUrl: './booking-queue-management.component.html',
    styleUrls: ['./booking-queue-management.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatIcon, MatSuffix, MatSelect, MatOption, MatInput, MatButton]
})
export class BookingQueueManagementComponent {

  addBookingQueueForm: any;

  constructor(private fb: FormBuilder){
    this.addBookingQueueForm = this.fb.group({
          eventType: [null],
          produtType: [null],
          gds: [''],
          branchName: [''],
        });
  }


}
